module.exports = __webpack_public_path__ + "img/section1-index-remove31.997bf2e2.png";